<div class="elevation-profile">
  <div class="elevation-profile__header">
    <span class="elevation-profile__title">{{
      'ElevationProfileDiagram.PlannedRoute' | translate
    }}</span>
    <button class="elevation-profile__close" (click)="close()">
      <span class="dv-icons">close</span>
    </button>
  </div>
  <div echarts [options]="chartOptions()" class="elevation-profile__chart"></div>
  <div class="elevation-profile__stats">
    <div class="elevation-profile__stat">
      <span class="elevation-profile__stat-label"
        >{{ 'ElevationProfileDiagram.Length' | translate }}:</span
      >
      <span class="elevation-profile__stat-value">
        {{ (summary().TotalDistanceMeters / 1000).toFixed(1) }} km
      </span>
    </div>
    <div class="elevation-profile__stat">
      <span class="elevation-profile__stat-label"
        >{{ 'ElevationProfileDiagram.Ascent' | translate }}:</span
      >
      <span class="elevation-profile__stat-value" [style.color]="'var(--dv-text-error)'">
        <span class="dv-icons icon-ascent">wind_direction</span>
        {{ summary().TotalAscentMeters.toFixed(0) }} m
      </span>
    </div>
    <div class="elevation-profile__stat">
      <span class="elevation-profile__stat-label"
        >{{ 'ElevationProfileDiagram.Descent' | translate }}:</span
      >
      <span class="elevation-profile__stat-value" [style.color]="'var(--dv-text-success)'">
        <span class="dv-icons icon-descent">wind_direction</span>
        {{ summary().TotalDescentMeters.toFixed(0) }} m
      </span>
    </div>
  </div>
</div>
